<template>
  <div class="home">
    <header-view curr="7"></header-view>
	
    <div class="body">
		<div class="boxtitle">
			<titleview title="机构展示" color="#E61F26" class="left"></titleview>
		</div>	
      <div class="titlecar">机构展示</div>
      <div class="subtitle">
        <span>{{ "来源：" + Institutional.name }}</span>
        <span>{{ " 发布时间：" + Institutional.establishedDate }}</span>
      </div>
      <div v-html="Institutional.introduction" style="margin-bottom: 1rem;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Institutional",

  data: function() {
    return {
      Institutional: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      var that = this;
      this.httpGet("web/statisticsController/getMechanismConfig", {}).then(
        res => {
          console.log(res.result);
          that.Institutional = res.result;
        }
      );	
	  
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;
	  
    }
  },
  mounted() {}
};
</script>
<style scoped=" scoped" lang="scss">
.home {
  ::-webkit-scrollbar { width: 0 !important }
  // background: #f4f5f9;
  width: 100%;
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    // min-height: 10rem;
	height: 10rem;
    // height: 100%;
    background: #ffffff;
    margin: 2.22rem auto 0;
    padding: 0 0.7rem;
    // overflow: hidden;
	overflow-y: auto;
    .titlecar {
      margin-top: 0.67rem;
      font-size: 0.28rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .subtitle {
      margin-top: 0.21rem;
      font-size: 0.14rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      span {
        display: inline-block;
        margin-right: 0.4rem;
        margin-bottom: 0.45rem;
      }
    }
    
	.boxtitle {
	    width: 10.62rem;
	    overflow: hidden;
	    margin: 0.1rem 0 0.2rem -0.2rem;
	    border-bottom: 0.01rem solid rgba(140, 140, 140, 0.24);
	}
	
  }
}
</style>
